<template>
  <q-page padding>
    <q-card
      class="my-card"
      flat
      bordered
    >
      <q-item>
        <q-item-section avatar>
          <q-avatar>
            <q-icon name="info" />
          </q-avatar>
        </q-item-section>

        <q-item-section>
          <q-item-label>About</q-item-label>
          <q-item-label caption>
            About me.
          </q-item-label>
        </q-item-section>
      </q-item>
      <q-separator inset />
      <q-card-section>
        <p>Olá, sou Abraão Pinto <br>
          Desenvolvedor, entusiasta por tecnologias de desenvolvimento web e mobile. <br>
          Estou interessado em tecnologia frontend javascript, vuejs, quasar e backend java, spring. <br>
          Atualmente, estou aprendendo javascript, vuejs, quasar. <br>
          Estou procurando colaboradores para repositório de funções simples e úteis ou <a
            href="https://github.com/abraaopinto/useful-simple-functions"
            target="_blank"
            rel="noopener"
          >useful-simple-functions</a>.<br>
          Aqui está um PWA que utiliza algumas das funções presentes neste repositório, é um projeto básico porém funcional: <a
            href="https://changecase.app"
            target="_blank"
            rel="noopener"
          >Change Case</a>.<br>
          Como me encontrar <a
            href="https://abraao.dev"
            target="_blank"
            rel="noopener"
          >abraao.dev</a>.</p>
        <p>Boa codificação 👋</p>
      </q-card-section>
    </q-card>
  </q-page>
</template>
<script>
export default {
  name: 'About'
}
</script>
<style lang="stylus" scoped>
.my-card {
  width: 100%;
}
</style>
